import debug from 'debug';

import { LogService } from './log-service';

const log = debug('LogService:BoostBanner');

export class BoostBanner extends LogService {
	click(bannerID, bannerIndex) {

		this.launchDarklyFeature().then(async () => {
			let url = `/api/boost/banner/click/${this.settings.sessionID}`;
			const body = {};
	
			body.s = this.settings.sessionID;
			body.t = +new Date;
			body.b = bannerID;
			body.p = '1-' + bannerIndex;
			body.a = 'c';

			const response = await this.post({
				url: url,
				body: body
			})

			const message = {
				bannerID,
				response
			}

			log('Logged Click', message);
		});
	}

	view(bannerID, bannerIndex) {

		this.launchDarklyFeature().then(async () => {
			let url = `/api/boost/banner/view/${this.settings.sessionID}`;
			const body = {};
	
			body.s = this.settings.sessionID;
			body.t = +new Date;
			body.b = bannerID;
			body.p = '1-' + bannerIndex;
			body.a = 'v';

			const response = await this.post({
				url: url,
				body: body
			})

			const message = {
				bannerID,
				response
			}

			log('Logged View', message);
		});
	}
}

export let boostBanner = new BoostBanner();
